import { render } from "./Pupup.vue?vue&type=template&id=71b23bf3&scoped=true"
import script from "./Pupup.vue?vue&type=script&lang=js"
export * from "./Pupup.vue?vue&type=script&lang=js"

import "./Pupup.vue?vue&type=style&index=0&id=71b23bf3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b23bf3"]])

export default __exports__